module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAFVBMVEUAKGgaPnemtMrOESbm6vDq7fP///87d1AcAAAANElEQVQY02MwRgUMlPKxAyEXRWQuY1haqgASnyktLU0Bic8C5Dvg4aOrRzcP3T4kQGX/AgA9yCbJEcZ+pgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/la.png
// module id = 866
// module chunks = 0